import { api } from './client';
import type { AppLikeOverviewParams, AppLikeOverviewResponse } from './applovinDashboard';

export type BingDateGrain = 'day' | 'week' | 'month' | 'year';

export interface BingOverviewRow {
  date_label: string;
  spend: number;
  revenue: number;
  impressions: number;
  clicks: number;
  add_to_cart_count: number;
  purchases: number;
  account_roi: number;
  cpa: number;
  ctr: number;
  cpc: number;
  click_add_to_cart_rate: number;
  click_purchase_rate: number;
  cost_per_add_to_cart: number;
  aov: number;
}

export interface BingOverviewResponse {
  list: BingOverviewRow[];
  summary: BingOverviewRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
}

export interface BingOverviewParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain?: BingDateGrain;
}

export type BingReportType = 'overview' | 'ad_form' | 'new_old' | 'detail';

export interface BingReportRow {
  dimensions: Record<string, string>;
  metrics: Record<string, number>;
}

export interface BingReportResponse {
  list: BingReportRow[];
  summary: BingReportRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: BingReportType;
}

export interface BingReportParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: BingReportType;
  dimensions?: string;
  new_old_type?: string;
  ad_form_type?: string;
}

export interface VooglamBingOverviewParams extends AppLikeOverviewParams {
  dimensions?: string;
  country?: string;
  campaign_type?: string;
  customer_segmentation?: string;
}

interface ApiEnvelope<T> {
  code: number;
  message: string;
  data: T;
}

export const bingDashboardApi = {
  getOverview: (params: BingOverviewParams) =>
    api.get<ApiEnvelope<BingOverviewResponse>>('/ad-dashboard/bing/overview', { params }),
  getReport: (params: BingReportParams) =>
    api.get<ApiEnvelope<BingReportResponse>>('/ad-dashboard/bing/report', { params }),
  getVooglamOverview: (params: VooglamBingOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/bing/v/overview', { params }),
  getVooglamTrend: (params: VooglamBingOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/bing/v/trend', { params }),
};
